import type { ApolloError } from "@apollo/client";

const INVALID_DESTINATION_NAME = "ELT_SYNC_INVALID_DESTINATION_NAME_FORMAT";

/** The backend rejects a malformed or already-used schema name with this code. */
export function getSchemaNameError(error: ApolloError): string | null {
  const match = error.graphQLErrors.find(
    (e) => e.extensions?.code === INVALID_DESTINATION_NAME,
  );
  return match?.message ?? null;
}
